import { isAddress } from 'ethers/lib/utils'
import { lazy } from 'react'
import { Navigate, useParams } from 'react-router-dom'

const TokenDetails = lazy(() => import('./index'))

export function RedirectInvalidToken() {
  const { address } = useParams<{ address: string }>()

  if (!isAddress(address ?? '')) {
    return <Navigate to="/liquidity" replace />
  }
  return <TokenDetails />
}
